import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const sectionIds = [
  "header",
  "features",
  "about",
  "services",
  "partners",
  "loan-service",
  "our-app",
  "contact",
];

useEffect(() => {
  const sections = sectionIds
    .map((id) => document.getElementById(id))
    .filter(Boolean);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    },
    {
      threshold: 0.6,
    }
  );

  sections.forEach((section) => observer.observe(section));

  return () => {
    sections.forEach((section) => observer.unobserve(section));
  };
}, []);
const observer = new IntersectionObserver(
  (entries) => {
    const visible = entries
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

    if (visible.length > 0) {
      setActiveSection(visible[0].target.id);
    }
  },
  {
    threshold: [0.3, 0.6, 0.9],
  }
);

  const handleDashboardClick = () => {
    setIsOpen(false);
    navigate("/login");
  };

  const handleScrollLink = (id) => {
    setIsOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    window.history.replaceState(null, "", `#${id}`);
  };

  // Scroll to section on page load if URL has a hash
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <nav id="menu" className="navbar navbar-expand-lg navbar-light fixed-top bg-light">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <a
          className="navbar-brand page-scroll"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
            setIsOpen(false);
          }}
        >
          Altrange
        </a>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          {isOpen ? (
            <span style={{ fontSize: "1.5rem", lineHeight: "1" }}>&times;</span>
          ) : (
            <span className="navbar-toggler-icon"></span>
          )}
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {[
              { href: "#features", label: "Features", scrollable: true },
              { href: "#about", label: "About", scrollable: true },
              { href: "#services", label: "Services", scrollable: true },
              { href: "#partners", label: "Our Partners", scrollable: true },
              { href: "#loan-service", label: "Loan Service", scrollable: true },
              { href: "#our-app", label: "Our App", scrollable: true },
              { href: "#contact", label: "Contact", scrollable: true },
            ].map((item, index) => (
              <li className="nav-item" key={index}>
                {item.scrollable ? (
                 <button
  className={`nav-link btn btn-link ${
    activeSection === item.href.replace("#", "") ? "active-link" : ""
  }`}
  onClick={() => handleScrollLink(item.href.replace("#", ""))}
>
  {item.label}
</button>
                ) : (
                  <a
                    href={item.href}
                    className="nav-link page-scroll"
                    onClick={() => setIsOpen(false)}
                  >
                    {item.label}
                  </a>
                )}
              </li>
            ))}

            <li className="nav-item">
              <button className="dashboard-lnk" onClick={handleDashboardClick}>
                Login Here <span className="arrow">→</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
